import {Dimensions, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  refreshControl: {zIndex: 100},
  noShiftContainer: {
    height: Dimensions.get('screen').height * 0.7,
  },
  contentContainerStyle: {flexGrow: 1},
});
